/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import styled from "styled-components";
import { Card } from "react-bootstrap";

export const HeaderTitle = styled.h3`
  color: white;
  font-weight: bold;
  margin: 25px 10px;
`;

export const CardContainer = styled(Card)`
  background: rgba(255, 255, 255, 0.15);
  border-radius: 16px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  border: 1px solid rgba(255, 255, 255, 0.28);
`;

export const SelectButtonStyle = {
  padding: "5px 40px 5px 10px",
};
